/** Différents types de filtres possibles. */
export enum EFilterType {
	avatar,
	datepicker,
	tags,
	dateRangePicker
}